import React, { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import MarkerMaps from './MarkerMaps';
import UsgsLegend from './UsgsLegend';
import PanelHeader from './PanelHeader';
import Error from './Error';
import ListMenu from './ListMenu';
import { getUsgsSfPts } from './routines';

export default function UsgsStreamflow(props) {
	const { mode, sfSaved, setSfSaved } = props;
	const [ panelError, setPanelError ] = useState(false);
	const [ showdm, setShowdm ] = useState(sfSaved["showdm"]);
	const [ sfperiod, setSfperiod ] = useState(sfSaved["period"]);

	const selectedState = "vt";
	const prefix = mode === 'dev' ? "vt/" : "https://nedews.nrcc.cornell.edu/";
    const sfFileNames = {
		"1-Day": prefix + "data/sf_1d.json", 
		"7-Day": prefix + "data/sf_7d.json",
		"14-Day": prefix + "data/sf_14d.json",
		"28-Day": prefix + "data/sf_28d.json",
	};
	const sfTitle = "Streamflow";
   	const mapTitle = sfperiod + " " + sfTitle + " Status";
	const buttonValue = null;
	const addtext = " ";
	const sfList = Object.keys(sfFileNames);
 
	useEffect(() => {
		setSfSaved({...sfSaved, period:sfperiod});
		// eslint-disable-next-line
	}, [sfperiod]);	
	
	useEffect(() => {
		setSfSaved({...sfSaved, showdm:showdm});
		// eslint-disable-next-line
	}, [showdm]);

	useEffect(() => {
        if (!sfSaved["markers"]) {
			getUsgsSfPts(sfFileNames, sfSaved, setSfSaved, setPanelError);
        }
		// eslint-disable-next-line
	}, [])

	return (
		<>
			{!panelError &&
				<PanelHeader
					title={sfTitle+" Summary"}
					buttonValue={buttonValue}
					addtext={addtext}
					showdm={showdm}
					setShowdm={setShowdm}
				/>
			}
			{sfSaved["markers"] && !panelError &&
				<div className="mapandlegend-container">
					<MarkerMaps 
						selectedState={selectedState} 
						markers={sfSaved["markers"][sfperiod]} 
						mapTitle={mapTitle}
						geo="basin"
						usdmOverlay={showdm} 
						mode={mode}
					/>
					<UsgsLegend 
						mapType={sfTitle.toLowerCase()}
						mapDate={sfSaved["date"]}
						cagType="usdm"
					/>
					<ListMenu
						selected={setSfperiod}
						list={sfList}
						title="Change Period"
					/>
				</div>
			}
			{!sfSaved["markers"] && !panelError &&
				<>
					<CircularProgress /> 
					<Typography display="inline" sx={{p:1}}>Loading</Typography>
				</>
			}
			{panelError &&
				<Error />
			}
	   </>
	);
}